<script>
export default {
  beforeRouteEnter (to, from, next) {
    localStorage.removeItem('vuex')
    window.location.replace('/login')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/auth/logout.vue